module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-login l-content"
  }, [_c('div', {
    staticClass: "header text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.secundo_logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginZone"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_c('v-ons-input', {
    attrs: {
      "id": "email",
      "placeholder": "Email",
      "modifier": "material"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('p', [_c('v-ons-input', {
    attrs: {
      "id": "password",
      "placeholder": "Mot de passe / Wachtwoord",
      "type": "password",
      "modifier": "material"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-ons-button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Connexion / Log in")]), _vm._v(" "), _c('v-ons-button', {
    attrs: {
      "modifier": "quiet"
    },
    on: {
      "click": _vm.password_forgotten
    }
  }, [_vm._v("Mot de passe oublié ? / Vergeten wachtwoord?")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222ef56","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 229
// module chunks = 0